<script>
  import * as d3 from 'd3';

  import {
    facilities,
    factorKey,
    highlightFacilityId,
    facilitySearchToggle,
    searchTerm,
    floodDomain,
    heatDomain,
    wildfireDomain,
    floodColorScaleBG,
    heatColorScaleBG,
    wildfireColorScaleBG,
    listCount
  } from './stores.js';

  let facilitySearchValue;

  function setFacility(facilityId) {
    // console.log(facilityId);
    highlightFacilityId.set(facilityId);
  }

  function factorSort(factor, a, b) {
    // console.log(
    //   factor,
    //   a.properties[factor],
    //   b.properties[factor],
    //   a.properties[factor] > b.properties[factor],
    //   a.properties[factor] < b.properties[factor]
    // );

    if (factor === 'flood_risk_rating') {
      //sort low confidence to the bottom always.
      if (
        a.properties.confidence === 'low' &&
        b.properties.confidence === 'low'
      ) {
        return 0;
      }
      if (a.properties.confidence === 'low') {
        return 1;
      }

      if (b.properties.confidence === 'low') {
        return -1;
      }

      if (a.properties.flood_risk_rating > b.properties.flood_risk_rating) {
        return -1;
      }

      if (a.properties.flood_risk_rating < b.properties.flood_risk_rating) {
        return 1;
      }

      // break flood risk rating ties with rp 100 depth.
      if (
        a.properties.depth_cm_100_year_flood >
        b.properties.depth_cm_100_year_flood
      ) {
        return -1;
      }

      if (
        a.properties.depth_cm_100_year_flood <
        b.properties.depth_cm_100_year_flood
      ) {
        return 1;
      }

      // true equals.
      return 0;
    }

    if (factor === 'wildfire_risk_rating') {
      // use mean_percentile for finer grained sorting
      if (a.properties.mean_percentile > b.properties.mean_percentile) {
        return -1;
      }
      if (a.properties.mean_percentile < b.properties.mean_percentile) {
        return 1;
      }
      return 0;
    }

    if (factor === 'heat_risk_rating') {
      // use hist_90 for finer grained sorting
      if (a.properties.hist_90 > b.properties.hist_90) {
        return -1;
      }
      if (a.properties.hist_90 < b.properties.hist_90) {
        return 1;
      }
      return 0;
    }
  }

  function getDomain() {
    switch (factorKey) {
      case 'flood_risk_rating':
        return $floodDomain;
      case 'heat_risk_rating':
        return $heatDomain;
      case 'wildfire_risk_rating':
        return $wildfireDomain;
      default:
        return [1, 1];
    }
  }

  function getColorScale(factorKey) {
    switch (factorKey) {
      case 'flood_risk_rating':
        return floodColorScaleBG;
      case 'heat_risk_rating':
        return heatColorScaleBG;
      case 'wildfire_risk_rating':
        return wildfireColorScaleBG;
      default:
        return floodColorScaleBG;
    }
  }

  function getColor(factorKey) {
    switch (factorKey) {
      case 'flood_risk_rating':
        return '#4492F7';
      case 'heat_risk_rating':
        return '#DD2E2A';
      case 'wildfire_risk_rating':
        return '#FFB800';
      default:
        return '#4492F7';
    }
  }

  facilitySearchToggle.subscribe((v) => {
    facilitySearchValue = v;
  });

  //<span class="dn">{$factorKey}: {facility.properties[$factorKey]}</span>
</script>

<!-- facility list -->
<ul
  style="background-color: #2C2B2B"
  class="overflow-scroll w-100 flex-wrap ph0 pt0 pb4 pb3-ns ma0 list facility-list mobile-list-height h-auto-ns {facilitySearchValue ===
    'facility' || $searchTerm
    ? 'flex'
    : 'dn'}"
>
  {#if $facilities.features.length === 0 && $searchTerm}
    <div class="near-white tc f4 w-100">No Search Results</div>
  {:else}
    {#each $facilities.features
      .sort(factorSort.bind(null, $factorKey))
      .slice(0, $searchTerm ? $facilities.features.length : $listCount) as facility, i (facility.properties.facilityid)}
      <li
        class="dib w-100 ph3 pv3 bg-animate hover-bg-lightest-blue pointer near-white mt1"
        style="background: {$factorKey === 'flood_risk_rating' &&
        facility.properties.confidence === 'low'
          ? 'grey'
          : getColorScale($factorKey)(facility.properties[$factorKey])}"
        on:click={setFacility.bind(null, facility.properties.facilityid)}
      >
        <p class="bold ma0">{facility.properties.name}</p>
      </li>
    {/each}
  {/if}
</ul>

<!-- facility list -->
